'use strict';
import template from './mx-executor-grid.component.html';

export class MxExecutorGridController {
	static $inject = [
		'$q',
		'$element',
		'mx.internationalization',
		'mx.SolutionBuilderAgent.PersonalizationService',
		'mx.SolutionBuilderAgent.GridEnums',
		'mx.sb.Agent.DataQuery.Enums',
	];

	constructor($q, $element, i18n, personalizationService, GridEnums, DataQueryEnums) {
		this.$q = $q;
		this.i18n = i18n;
		this.personalizationService = personalizationService;
		this.GridEnums = GridEnums;
		this.DataQueryEnums = DataQueryEnums;
		this.disableDelete = true;
		this.gridValidationMessage = i18n.get('components.form-validation.required');

		this.initRowHeightSettings();
		this.initRowColoring();
	}

	get isInvalid() {
		return this.required && this.grid?.executor?.loading === false && (!this.grid?.executor?.dataItems || this.grid?.executor?.dataItems?.length === 0);
	}

	get disabled() {
		return this.grid?.disabled;
	}

	get readOnly() {
		return this.grid?.readOnly;
	}

	$onInit() {
		this.formValidationMessage =
			'<div flex layout="column" class="error-message_field-name">' +
			(this.label || '') +
			'</div><div flex layout="column" class="error-message_error-text">' +
			this.gridValidationMessage +
			'</div>';

		if (!this.fullHeight && typeof this.minHeight === 'number') {
			this.renderMinHeight = this.minHeight + 'px';
		}
	}

	$onChanges(changes) {
		if (this.destroyed) {
			return;
		}

		if (changes.enableRowSelection) {
			const enableRowSelection = changes.enableRowSelection.currentValue;
			this.enableRowSelection = typeof enableRowSelection === 'undefined' ? true : Boolean(enableRowSelection);
		}

		if (changes.enableDragAndDrop) {
			const enableDragAndDrop = changes.enableDragAndDrop.currentValue;
			this.enableDragAndDrop = typeof enableDragAndDrop === 'undefined' ? false : Boolean(enableDragAndDrop);
		}

		if (changes.grid && changes.grid.currentValue) {
			const editMode = changes.grid.currentValue.editMode;
			this.watchable = editMode === this.GridEnums.EditMode.Inline || editMode === this.GridEnums.EditMode.EditForm || editMode === this.GridEnums.EditMode.Wizard;
			this.initialized = true;
		}
	}

	$onDestroy() {
		this.destroyed = true;
	}

	onSortingChanged(columns) {
		if (this.grid.executor.preprocessors.sortingPreprocessor) {
			columns = (columns || []).map(function (column) {
				return {
					name: column.field,
					sorting: column.sort.direction === 'asc' ? this.DataQueryEnums.ColumnSortingEnum.Ascending : this.DataQueryEnums.ColumnSortingEnum.Descending,
					priority: column.sort.priority,
				};
			}, this);
			columns.sort(function (columnA, columnB) {
				return columnA.priority - columnB.priority;
			});
			this.grid.executor.preprocessors.sortingPreprocessor.setSort(columns);
		}
	}

	onColumnPositionChanged(column, oldPosition, newPosition, columns) {
		var positionConfig = {};
		columns.forEach(function (column, i) {
			positionConfig[column.name] = i;
		});
		this.grid.executor.changeColumnsPositions(positionConfig);
	}

	onColumnSizeChanged(column, columnWidthShift, absoluteWidth) {
		this.grid.executor.changeColumnSize(column.name, absoluteWidth);
	}

	initRowHeightSettings() {
		var vm = this;

		vm.availableRowHeights = [
			{
				size: 22,
				title: vm.i18n.get('solutionBuilderAgent.common.high'),
			},
			{
				size: 30,
				title: vm.i18n.get('solutionBuilderAgent.common.normal'),
			},
			{
				size: 38,
				title: vm.i18n.get('solutionBuilderAgent.common.low'),
			},
		];

		var rowHeight = vm.availableRowHeights[0].size;
		Object.defineProperty(vm, 'rowHeight', {
			get: function () {
				return rowHeight;
			},
			set: function (newRowHeight) {
				rowHeight = newRowHeight || vm.availableRowHeights[0].size;
				vm.personalizationService.setRowHeight(rowHeight);
			},
		});

		return vm.personalizationService.getRowHeight().then(function (savedRowHeight) {
			rowHeight = savedRowHeight === undefined ? rowHeight : savedRowHeight;
		});
	}

	initRowColoring() {
		var vm = this;
		var rowColoringEnabled = true;

		Object.defineProperty(vm, 'rowColoringEnabled', {
			get: function () {
				return rowColoringEnabled;
			},
			set: function (newValue) {
				rowColoringEnabled = Boolean(newValue);
				vm.personalizationService.setRowsColoringAttribute('rowColoringEnabled', rowColoringEnabled);
			},
		});

		return vm.personalizationService.getRowsColoring().then(function (coloring) {
			rowColoringEnabled = coloring.enabled === undefined ? rowColoringEnabled : coloring.enabled;
		});
	}

	onItemClick(item) {
		this.grid.itemClickHandler(item);
	}

	onItemRightClick(item) {
		this.grid.itemRightClickHandler(item);
	}

	onItemDblClick(item) {
		this.grid.itemDblClickHandler(item);
	}

	onGroupingClick(column) {
		this.grid.groupingClickHandler(column);
	}

	onReorder() {
		this.grid.reorderHandler();
	}

	onCellChanged() {
		// this.grid.reorderHandler();
	}
}

export default {
	bindings: {
		grid: '<',

		enableRowSelection: '<',
		enableSelectionPicker: '<',
		enableDragAndDrop: '<',
		fullHeight: '<',
		minHeight: '<',
		label: '<',

		required: '<',
	},
	require: {
		mxForm: '?^mxForm',
	},
	template: template,
	controller: MxExecutorGridController,
	controllerAs: 'vm',
};
